import React from 'react';
import { useNotification } from '@nusrif/contexts';
import { NotificationToast } from './NotificationToast';

export const NotificationContainer: React.FC = () => {
  const { notifications, hideNotification } = useNotification();

  return (
    <>
      {notifications.map((notification, index) => (
        <NotificationToast
          key={notification.id}
          notification={notification}
          onClose={() => hideNotification(notification.id)}
          index={index}
        />
      ))}
    </>
  );
}; 